/**
 * Read More/Read Less Handler
 * Bu script, içeriğin belirli bir yüksekliği aşması durumunda "Daha Fazla/Daha Az" butonlarını yönetir.
 */
document.addEventListener('DOMContentLoaded', function() {
  // İlklendirme fonksiyonu
  function initCollapsibleText() {
    console.log('Read More Handler başlatılıyor...');
    // Tüm Daraltılabilir metin elemanlarını bul
    const collapsibleElements = document.querySelectorAll('.js-collapsible-text');
    
    if (collapsibleElements.length === 0) {
      console.log('Daraltılabilir metin elemanı bulunamadı!');
      return;
    }
    
    console.log('Bulunan daraltılabilir metin sayısı:', collapsibleElements.length);
    
    collapsibleElements.forEach(function(element, index) {
      // Daha önce işlenmiş mi kontrol et
      if (element.dataset.initialized === 'true') {
        console.log('Element zaten işlenmiş, atlanıyor...');
        return;
      }
      
      // İşlendiğini işaretle
      element.dataset.initialized = 'true';
      
      // Maksimum yüksekliği al (varsayılan: 300px)
      const maxHeight = parseInt(element.dataset.maxHeight || 300);
      const fullHeight = element.scrollHeight;
      const toggleButton = element.querySelector('.js-read-more-toggle');
      
      console.log(`Element ${index} - Max Height: ${maxHeight}px, Full Height: ${fullHeight}px`);
      
      if (!toggleButton) {
        console.log('Düğme bulunamadı!');
        return;
      }
      
      // Çeviri metinlerini al
      const expandedText = 'Daha Az Göster';
      const collapsedText = 'Daha Fazla Göster';
      toggleButton.textContent = collapsedText;
      
      // Eğer içerik maksimum yükseklikten daha azsa, butonları gizle
      if (fullHeight <= maxHeight + 50) { // 50px ekstra alan için tolerans
        console.log('İçerik kısa, buton gizleniyor...');
        toggleButton.parentNode.style.display = 'none';
        element.style.marginBottom = '0';
        return;
      }
      
      // İlk yükleme durumunda içeriği daralt
      element.style.maxHeight = maxHeight + 'px';
      element.style.overflow = 'hidden';
      element.style.position = 'relative';
      element.style.transition = 'max-height 0.5s ease';
      
      // İçeriğin başlangıç pozisyonunu sakla
      const elementTopPosition = element.getBoundingClientRect().top + window.pageYOffset;
      element.dataset.topPosition = elementTopPosition;
      
      // Buton için tıklama olayı ekle
      toggleButton.addEventListener('click', function(e) {
        e.preventDefault(); // Buton tıklamasının varsayılan davranışını engelle
        console.log('Buton tıklandı!');
        
        const isExpanded = element.classList.contains('is-expanded');
        
        if (isExpanded) {
          // Daralt
          console.log('İçerik daraltılıyor...');
          element.style.maxHeight = maxHeight + 'px';
          element.classList.remove('is-expanded');
          toggleButton.textContent = collapsedText;
          
          // İçeriğin pozisyonuna git, sayfanın başına değil
          const elementCurrentPosition = element.getBoundingClientRect().top + window.pageYOffset;
          
          // İçeriğe doğru kayma ve biraz yukarda durma (header için boşluk)
          setTimeout(() => {
            const headerOffset = 80; // Header yüksekliğine göre ayarlayabilirsiniz
            const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
            const offsetPosition = elementPosition - headerOffset;
            
            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
            });
            console.log(`İçeriğin pozisyonuna kaydırılıyor: ${offsetPosition}px`);
          }, 100);
        } else {
          // Genişlet
          console.log('İçerik genişletiliyor...');
          element.style.maxHeight = (fullHeight + 100) + 'px'; // Biraz fazla alan ekle
          element.classList.add('is-expanded');
          toggleButton.textContent = expandedText;
        }
      });
      
      console.log('Buton etkinleştirildi!');
    });
  }
  
  // Sayfa yüklendikten sonra çalıştır
  console.log('Sayfa yüklendiğinde ilk çalıştırma...');
  setTimeout(function() {
    initCollapsibleText();
  }, 500);
  
  // Sayfa tam olarak yüklendikten sonra (resimler dahil) tekrar kontrol et
  window.addEventListener('load', function() {
    console.log('Sayfa tamamen yüklendi, tekrar çalıştırılıyor...');
    setTimeout(function() {
      initCollapsibleText();
    }, 1000);
  });
  
  // Tarayıcı penceresi yeniden boyutlandırıldığında tekrar kontrol et
  window.addEventListener('resize', function() {
    console.log('Pencere boyutu değişti, tekrar çalıştırılıyor...');
    setTimeout(initCollapsibleText, 500);
  });
}); 